import { TTheme } from '@/core/theme'
import Typography from '@/ui/components/typography'
import { LinkButton } from '@components/buttons/link'
import { styled } from '@mui/system'
import { alwaysShowScrollbar } from '../digitalFootprint/domainDiscovery/domainDiscovery.styles'

export const Wrapper = styled('div')`
    background-color: inherit;
    height: 100vh;

    .text {
        color: var(--color-greys-800);
        padding: 4px 0;
    }

    .buttons {
        margin-left: auto;
        margin-right: 30px;
        display: flex;
        gap: 2px;

        div {
            height: 24px;
            width: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 700;
            font-size: var(--font-size-xs);
            line-height: 15px;
            cursor: pointer;
            transition: all 0.2s linear;
            user-select: none;
            background-color: var(--color-primary);
            color: var(--color-dark-900);

            &:hover {
                background-color: var(--color-primary-700);
            }

            &.is-disabled {
                background-color: var(--color-dark-400);
                cursor: not-allowed;
            }
        }

        .prev {
            border-bottom-left-radius: 12px;
            border-top-left-radius: 12px;
            padding-left: 5px;
        }

        .next {
            border-bottom-right-radius: 12px;
            border-top-right-radius: 12px;
            padding-right: 5px;
        }
    }
`
export const Body = styled('div')<{ theme?: TTheme }>`
    display: flex;
    flex-direction: column;
    width: 100%;
`

export const DescriptionFlex = styled('div')`
    display: flex;
    justify-content: space-between;
    gap: 14px;
    margin: 20px 0;
`

export const Description = styled('div')`
    flex: 1;
`
export const PortText = styled('div')`
    overflow: initial !important;
`

export const ScrollableContainer = styled('div')`
    max-height: calc(100% - 59px);
    overflow-y: auto;
    ${alwaysShowScrollbar}
`

export const Flex = styled('div')`
    display: flex;
    gap: 8px;
    align-items: center;
`

export const HeaderFlex = styled(Flex)`
    align-items: center;
`

export const PortsFlex = styled(Flex)`
    gap: 4px;
`

export const SubHeader = styled('div')`
    display: flex;
    align-items: center;
    width: 100%;
    gap: 8px;
`

export const Seperator = styled('div')<{ theme?: TTheme }>`
    width: 100%;
    margin: 37px 0 20px 0;
    border-bottom: 2px dotted
        ${({ theme }) => `${theme.colors.semantic.topPageSeparator}`};
`

export const Title = styled(Typography)`
    color: var(--color-greys-0);
    padding: 0px !important;
`

export const TitleGrey = styled(Typography)<{ theme?: TTheme }>`
    color: ${({ theme }) => `${theme.colors.greys[400]}`};
`

export const Link = styled(LinkButton)`
    padding: 20px 0;
`

export const Separator = styled('div')<{ theme?: TTheme }>`
    border: none;
    border-top: ${({ theme }) => `dotted ${theme.colors.greys[800]} 4px`};
    height: 2px;
    width: 100%;
    margin: 24px 0;
`
